export default "__VITE_PUBLIC_ASSET__feff79fb__"